<!--
 * @Description: 员工变更管理
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-29 13:54:30
-->
<template>
  <div>
    <!-- <div style="position: absolute;right: 70px;top:120px;"
         v-if="$route.name=='staffVariation'"
         class="d-flex">
      <mrc_ess_uploadBtn type='1'
                         class="mr-3"
                         v-btnAuth="['upload-staff-movement-template']"
                         table='mrbase_sys_staff_movement'
                         :label="$t('label_Batch_Import')">
      </mrc_ess_uploadBtn>
      <v-btn rounded
             class="mr-3"
             v-btnAuth="['download-staff-movement-template']"
             @click="dialog=true"
             color="primary"
             dark>{{$t('label_Download_the_template')}}</v-btn>

    </div> -->
    <mrc_ess_table v-if="$route.name == 'staffVariation'" :headers="headers" pageName="addStaffVariation"
      :paginationOptions="options" @turnPage="getlist" :isLoading="loading" :slotKey="[
        'name',
        'result_status',
        'changeeffective',
        'transferred_staff_post_uuid',
        'movement_effective_utc_date',
      ]" :hideAddBtn="!hasBtn('add-staff-movement')" :items="desserts">
      <template v-slot:search>
        <v-row class="d-flex justify-end" style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px">
          <mrc_ess_advanceFilterAndSearchInput class="mt-4" v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })" :systemFieldMeta="systemFieldMeta"></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>

      <template v-slot:item.name="{ item }">
        <mrc_ess_staffListView :staffObj="item"></mrc_ess_staffListView>
      </template>

      <template v-slot:item.movement_effective_utc_date="{ item }">
        {{ item.movement_effective_utc_date | changeDate() }}
      </template>

      <template v-slot:item.transferred_staff_post_uuid="{ item }">
        <span>{{ INT(item.transferred_staff_post_uuid) }}</span>
        <!-- <div style="max-width: 500px;white-space: nowrap;;overflow: hidden;"
             class="d-flex align-center">
          <div style="max-width: 450px;white-space: nowrap;;overflow: hidden;">
            <mrc_ess_chip v-for="(uuid,index) in splitINT(item.transferred_staff_post_uuid)"
                    v-show="item.transferred_staff_post_uuid.length > 0"
                    :key='index'
                    style="font-size: 12px;height:28px">
              {{INT(uuid)}}
            </mrc_ess_chip>
          </div>
        </div>
        <span v-show="item.transferred_staff_post_uuid.length <= 0"></span> -->
      </template>

      <template #item.changeeffective="{ item }">
        <span>{{ item.Change_effective | changeDate() }}</span>
      </template>
      <!-- 状态 -->
      <template v-slot:item.result_status="{ item }">
        <v-chip rounded color="grey" small class="white--text" v-if="item.result_status == 0">{{ $t("label_Unchanged")
        }}</v-chip>
        <v-chip rounded color="#18A874" small class="white--text" v-if="item.result_status == 1">{{ $t("label_Complete")
        }}</v-chip>
        <v-chip rounded color="#18A874" small class="white--text" v-if="item.result_status == 2">{{
          $t("label_The_task_processing_is_complete") }}</v-chip>
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="[
          {
            name: $t('label_View'),
            show: hasBtn('view-staff-movement'),
            type: 'view',
          },
          {
            name: $t('label_Edit'),
            show: hasBtn('edit-staff-movement') && item.result_status == 0,
            type: 'edit',
          },
          {
            name: $t('label_delete'),
            show: hasBtn('delete-staff-movement') && item.result_status == 0,
            type: 'del',
          },
        ]" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon v-btnAuth="[
              'view-staff-movement',
              'edit-staff-movement',
              'delete-staff-movement',
            ]">mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
    <mrc_ess_myDialog v-model="dialog" :title="$t('label_Upload_CVS')" width="847" :disabled="false">
      <mrc_ess_myStep :list="stepList" v-model="stepIndex">
        <template v-slot:1>
          <span>
            {{ $t("label_file") }}
          </span>
          <mrc_ess_brandupload :isShow="false"></mrc_ess_brandupload>
          <mrc_ess_submitBtn @success="changeIndex(2)" :successText="$t('label_The_next_step')" @cancel="changeIndex(0)">
          </mrc_ess_submitBtn>
        </template>
        <template v-slot:2>
          <mrc_ess_submitBtn @success="changeIndex(3)" :cancel="$t('label_The_previous_step')" @cancel="changeIndex(1)">
          </mrc_ess_submitBtn>
        </template>
      </mrc_ess_myStep>
    </mrc_ess_myDialog>
  </div>
</template>

<script>
import { getStaffListForFilter } from "@/service/api/autoComplete.js"
import {
  getStaffVariationList,
  detailStaffVariation,
  addStaffVariation,
  updateStaffVariation,
  deleteStaffVariation,
  getallList,
} from "@/service/api/staffmsg.js"
import Cookie from "js-cookie"
import {
  uploadFileAll,
  uploadFileUser,
  uploadFileOrg,
} from "@/service/api/upload.js"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      allList: [],
      fn: null,
      uploadLoading: null,
      resStatus: null,
      stepIndex: 1,
      dialog: false,
      disabled: true,
      list: {},
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      desserts: [],
    }
  },
  beforeDestroy() {
    this.$ls.remove("staffList")
  },
  computed: {
    stepList() {
      return [
        {
          name: this.$t("label_Importing_files"),
        },
        {
          name: this.$t("label_result"),
        },
      ]
    },
    // menulist () {
    //   return [
    //     {
    //       name: this.$t('label_View'),
    //       show: this.hasBtn('view-staff-movement'),
    //       type: 'view',
    //     },
    //     {
    //       name: this.$t('label_Edit'),
    //       show: this.hasBtn('edit-staff-movement'),
    //       type: 'edit',
    //     },
    //     {
    //       name: this.$t('label_delete'),
    //       show: this.hasBtn('delete-staff-movement'),
    //       type: 'del',
    //     },
    //   ]
    // },
    headers() {
      return [
        {
          text: this.$t("label_Transfer_personnel"),
          align: "start",
          value: "name",
          sortable: false,
        },
        {
          text: this.$t("label_New_position"),
          value: "transferred_staff_post_uuid",
          sortable: false,
        },
        {
          text: this.$t("label_The_effective_date"),
          value: "movement_effective_utc_date",
          sortable: false,
        },
        {
          text: this.$t("label_The_execution_status"),
          value: "result_status",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    $route(v) {
      if (v.name == "staffVariation") {
        this.getlist()
      }
    },
  },
  async mounted() {
    this.loading = true
    // await this.getdropDownList()
    await this.getlist()
    this.loading = false
  },

  methods: {
    async getdropDownList() {
      const res = await getallList({
        org_level_uuid: this.$store.state.currentCompany,
      })
      // const res = await getStaffListForFilter({
      //   org_level_uuid: this.$store.state.currentCompany
      // })
      if (res.code == 200) {
        this.allList = res.data
      }
    },
    changeIndex(v) {
      if (v == 0) {
        this.dialog = false
      } else if (v == 3) {
        //提交代码逻辑
      } else {
        this.stepIndex = v
      }
    },
    async getlist(obj) {
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj
        this.options = { ...this.options, ...obj }
      }
      const res = await getStaffVariationList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    addStaffLeave() {
      // this.$store.commit('set_subPage_name', '')
      this.$store.commit("set_uuid", "")
      this.$store.commit("set_iconstatus", "") //行内进图标显示
      this.$router.push({
        name: "addStaffVariation",
      })
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true) //行内进图标显示
      this.$store.commit("set_listObj", item) //保存这条数据
      // this.$store.commit('set_subPage_name', item.job_name)
      this.$store.commit("set_uuid", item.uuid) //
      this.$router.push({
        name: "detailStaffVariation",
      })
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj)
          break
        case "edit":
          // this.$store.commit('set_subPage_name', obj.job_name)
          this.$store.commit("set_listObj", obj) //保存这条数据
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$router.push({
            name: "detailStaffVariation",
          })
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteStaffVariation({ uuid: obj.uuid }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                })
                if (this.desserts.length == 1) this.options.cpage--
                this.getlist()
              }
            })
          })
          break
      }
    },
    success() { },
    cancel() { },
  },
}
</script>

<style scoped></style>
